// Shared state for the country chooser.
//
// `langConfirmed` is the single language cookie and is written only here, only on an explicit
// action: picking a country, or dismissing the dialog (which means staying in the current
// language). Nothing server side writes it - LanguageDetectionHandler only reads it, to
// redirect the site root. The value is a language URL prefix such as 'de-at'.
//
// Lives outside ./controllers because main.js imports it too, and require.context() in main.js
// registers every module under ./controllers as a Stimulus controller.

const COOKIE = 'langConfirmed'
const ONE_YEAR = 60 * 60 * 24 * 365

export function hasLanguageCookie() {
  return new RegExp('(?:^|;\\s*)' + COOKIE + '=').test(document.cookie)
}

export function setLanguageCookie(value) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = COOKIE + '=' + encodeURIComponent(value) +
    '; Path=/; Max-Age=' + ONE_YEAR + '; SameSite=Lax' + secure
}

// Klaro's consent dialog is held back until the country question is settled, so the two never
// stack on a first visit. main.js installs the release callback; this is a no-op when Klaro is
// disabled or was never deferred.
export function releaseKlaro() {
  if (typeof window.releaseKlaro === 'function') {
    window.releaseKlaro()
  }
}
